<template>
  <section class="app-main">
    <router-view v-show="!iframeShowUrl"  v-if="canRenderContent"/>
    <iframe :src="iframeShowUrl" id="contentIframe" frameborder="0" v-if="iframeShowUrl"></iframe>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'AppMain',
    data() {
      return {
        routerShow: true,
        homeUrl: '',
      }
    },
    props: {
      iframeShowUrl: { default: false }
    },
    computed: mapState({
      canRenderContent: state => state.animation.canRenderContent,
    }),
    mounted() {
    },
    methods: {}
  }
</script>

<style lang="less">
  .app-main {
    box-sizing: border-box;
    min-height: calc(100vh - 50px);
    padding: 15px;
    position: relative;
    overflow: hidden;
    #contentIframe {
      border: 0;
      height: calc(100vh - 55px);
      width: 100%;
    }
  }
</style>
